import { useMemo } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import translations from './i18n.json';

import {
  spacing,
  fontSize,
  borderRadius,
  fontWeight,
} from 'presentations/views/styles';
import Icon from 'presentations/views/components/atoms/Icon';
import { black } from 'presentations/views/styles/color';
import Link from 'presentations/views/components/atoms/Link';
import { translateInComponent } from 'infras/i18n';
import { CalendarViewType } from 'domains/models/event_type/calendarViewType';

interface Props {
  calendarViewType: CalendarViewType;
  onClick?: any;
  color?: string;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);

  const labelText = useMemo(() => {
    if (
      [
        CalendarViewType.Week,
        CalendarViewType.CalendarWeekLegacy,
        CalendarViewType.WeekCalendar,
      ].includes(props.calendarViewType)
    ) {
      return t('Link next week');
    } else if (
      [CalendarViewType.ListTime, CalendarViewType.GridTime].includes(
        props.calendarViewType,
      )
    ) {
      return t('Link next period');
    }

    return t('Link next month');
  }, [t, props.calendarViewType]);

  return (
    <StyledContainer selectedColor={props.color} onClick={props.onClick}>
      <StyledDescription>{t('Description')}</StyledDescription>
      <StyledLabelContainer>
        <StyledIcon selectedColor={props.color} name="chevron-right" />
        <StyledLabel>{labelText}</StyledLabel>
      </StyledLabelContainer>
    </StyledContainer>
  );
}

const StyledDescription = styled.div`
  color: ${black};
  font-size: ${fontSize(13)};
  margin-bottom: ${spacing(8)};
`;

const StyledLabelContainer = styled.div`
  display: flex;
  align-items: center;
`;
const StyledIcon = styled(Icon)<{
  selectedColor?: string;
}>`
  width: 24px !important;
  height: 24px !important;
  ${({ selectedColor }) => css`
    color: ${selectedColor || ''};
  `}
`;
const StyledLabel = styled.div`
  font-size: ${fontSize(16)};
  font-weight: ${fontWeight('bold')};
  color: ${black};
`;

const StyledContainer = styled(Link)<{
  selectedColor?: string;
}>`
  display: flex;
  flex-direction: column;
  border: 1px solid
    ${({ selectedColor }) => css`
      ${selectedColor || ''};
    `};
  border-radius: ${borderRadius(6)};
  padding: ${spacing(16)} ${spacing(40)};
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.15);
  background-color: white;
  align-items: center;
  color: ${black};
  :hover,
  :hover ${StyledLabel} {
    ${({ selectedColor }) => css`
      color: ${selectedColor || ''};
    `}
  }
`;
